import { EARLY_SOLVER_BONUS, EARLY_SOLVER_COUNT, MAX_GUESSES, SOLVE_POINTS } from "../_logic/constants";
import { STATUS_CLASSES } from "./tileStyles";

/** Fixed example words, each highlighting one tile. Keep them off every answer list, including RISE (`rise-games/_logic/puzzles.server.ts`). */
const EXAMPLES = [
  { word: "BRASS", index: 0, status: "correct", text: "is in the word and in the right spot" },
  { word: "JAZZY", index: 2, status: "present", text: "is in the word but in the wrong spot" },
  { word: "BEADS", index: 4, status: "absent", text: "isn't in the word" },
] as const;

/**
 * How to play and how points are earned.
 * @returns The rules block.
 */
export function WordleRules() {
  return (
    <div className="flex flex-col gap-4 text-left">
      <div className="flex flex-col gap-2">
        <h3 className="text-sm font-semibold text-slate-900">How to play</h3>
        <p className="text-sm font-medium text-slate-600">
          Guess the 5-letter word in {MAX_GUESSES} tries. The clock starts when you hit start.
        </p>
        <ul className="flex flex-col gap-3">
          {EXAMPLES.map(({ word, index, status, text }) => (
            <li key={word} className="flex flex-col gap-1.5">
              <div className="flex gap-1" aria-hidden="true">
                {word.split("").map((letter, i) => (
                  <span
                    key={i}
                    className={`flex h-8 w-8 items-center justify-center rounded-md border-2 text-sm font-bold ${
                      i === index ? STATUS_CLASSES[status] : "border-slate-300 bg-white text-slate-900"
                    }`}
                  >
                    {letter}
                  </span>
                ))}
              </div>
              <p className="text-sm font-medium text-slate-600">
                <span className="font-semibold text-slate-900">{word[index]}</span> {text}
              </p>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-col gap-2">
        <h3 className="text-sm font-semibold text-slate-900">Points</h3>
        <ul className="flex flex-col gap-1 text-sm font-medium text-slate-600">
          <li>
            <span className="font-semibold text-slate-900">{SOLVE_POINTS} pts</span> for solving
          </li>
          <li>
            <span className="font-semibold text-slate-900">+{EARLY_SOLVER_BONUS} pts</span> if you&apos;re one of the
            first {EARLY_SOLVER_COUNT} solvers today
          </li>
          <li>
            <span className="font-semibold text-slate-900">+1 pt</span> for every day in your streak, added to the
            Friday leaderboard
          </li>
        </ul>
        <p className="text-xs font-medium text-slate-500">
          Ties go to fewer guesses, then the faster time. Your first round each day is the one that counts.
        </p>
      </div>
    </div>
  );
}
